import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

import StringAssociativeArrayInterface from '../../../types/StringAssociativeArrayInterface';
import { IColumn, SelectableType } from './types';

export interface IRowProps {
    columns: Array<IColumn>
    row: StringAssociativeArrayInterface<any>
    selectable?: SelectableType
    selected?: boolean
    onClick?: () => void
    onEdit?: (id: number) => void
    onDelete?: (id: number) => void
}

function Row({ columns, row, selectable, selected, onClick, onEdit, onDelete }: IRowProps) {
    const className = [];

    if (selectable) className.push('cursor-pointer');
    if (selected && selectable === 'single') className.push('selected');

    return (
        <tr
            className={className.join(' ')}
            onClick={() => onClick && onClick()}>
            {
                columns.map(({ key, formatuj }) => (
                    <td key={key} className='pr-5'>
                        {formatuj ? formatuj(row[key]) : row[key]}
                    </td>
                ))
            }
            {
                (onEdit || onDelete) &&
                <td style={{
                    width: 52,
                    textAlign: 'right'
                }}>
                    {
                        onEdit &&
                        <button
                            className='cursor-pointer text-info'
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row.id);
                            }}>
                            <FontAwesomeIcon
                                icon={icon({ name: 'pen' })}
                                size='sm' />
                        </button>
                    }
                    {
                        onDelete &&
                        <button
                            className='cursor-pointer text-error'
                            onClick={(e) => {
                                e.stopPropagation();
                                // eslint-disable-next-line no-restricted-globals
                                onDelete(row.id);
                            }}>
                            <FontAwesomeIcon
                                icon={icon({ name: 'trash' })}
                                size='sm' />
                        </button>
                    }
                </td>
            }
        </tr>
    );
}

export default Row;
